
    <div class="flex-center">
      <a href="https://twitter.com/" target="_blank"><i class="fa fa-twitter icon-3d"></i></a>
      <a href="https://www.facebook.com" target="_blank"><i class="fa fa-facebook icon-3d"></i></a>
      <a href="https://www.instagram.com/" target="_blank"><i class="fa fa-instagram icon-3d"></i></a>
      <a href="mailto:giulianogustavotritto@gmail.com" target="_blank"><i class="fa fa-envelope icon-3d"></i></a>
    </div>
    <div id="texto">
      {{anio}} ASTRONOMIUM© Todos los derechos reservados
    </div>
  
